var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibility = function SvgAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    color: "#FFF"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "nonzero",
    d: "M11.25 5a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 8.75 2.5q0-1.03.734-1.766A2.4 2.4 0 0 1 11.25 0q1.032 0 1.766.734.734.735.734 1.766t-.734 1.766T11.25 5M7.5 25V8.75q-1.874-.156-3.812-.469A37 37 0 0 1 0 7.5L.625 5q2.437.657 5.188.953 2.75.297 5.437.297t5.438-.297A34 34 0 0 0 21.875 5l.625 2.5a37 37 0 0 1-3.687.781A50 50 0 0 1 15 8.75V25h-2.5v-7.5H10V25z"
  })));
};
export default SvgAccessibility;